module.exports = "<div class=\"label-icon\">\n  <span class=\"icon medium\" [ngClass]=\"icon\"></span>\n  <span class=\"text\" *ngIf=\"showText\" [ngClass]=\"textClass\">\n    <div class=\"title\" [ngClass]=\"titleClass\">{{title}}</div>\n    <div class=\"subtitle\" [ngClass]=\"subtitleClass\">{{subtitle}}</div>\n  </span>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./~/@c4/programming/src/app/common/label-icon/label-icon.component.html
// module id = 1531
// module chunks = 2